module.exports = __webpack_public_path__ + "img/view_form_filled_icon.e7d0fac7.svg";